import { BaseWidgetComponent } from '../base-widget/base-widget.component'
import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'

@Component({
  selector: 'app-channel-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './channel-banner.component.html',
  styleUrls: ['./channel-banner.component.scss'],
})
export class ChannelBannerComponent extends BaseWidgetComponent {
  override enableVisibilityControl = true
}
